// extracted by mini-css-extract-plugin
export default {"markdown":"Markdown_markdown__cKhqv","showFullText":"Markdown_showFullText__zIT+V"};